<!--
  템플릿 레이아웃 컴포넌트의 메인 템플릿
  - 헤더, 메인 컨텐츠 영역, 푸터, 사이드 메뉴를 포함
  - 반응형 디자인을 위한 모바일 대응 구조
-->

<!-- 구조화된 데이터 -->
<script type="application/ld+json">
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "K-Beauty",
    "url": "https://kbeauty.com",
    "description": "K-Beauty"
  }
</script>

<!--
  모바일(앱) 화면에서 사용되는 사이드 메뉴
  - Material Design의 Sidenav 컴포넌트를 참고하여 구현
  - 오른쪽에서 슬라이드되는 메뉴 구조
-->
<!-- 참고 URL https://material.angular.io/components/sidenav/overview -->

<header class="sticky-top" role="banner">
  <!--
    헤더 컴포넌트
    - 사용자 정보, 포인트 카드 정보 표시
    - 언어 변경 기능 (canChangeLanguage 값에 따라 표시 여부 결정)
    - 정보 새로고침 기능
  -->
  <app-template-header
    [userInfo]="userInfo"
    [userCard]="userCard"
    [canChangeLanguage]="canChangeLanguage"
    (refreshInfoClick)="onRefreshInfoClick()"
  ></app-template-header>
</header>

<main role="main">
  <!--
    라우터 아울렛
    - 메인 컨텐츠 영역을 표시하는 라우팅 컴포넌트
  -->
  <router-outlet></router-outlet>
</main>

<!-- 오른쪽 고정 메뉴 -->
<div class="fixed-menu" role="navigation" aria-label="빠른 메뉴">
  <ul class="menu-list">
    <li>
      <a
        class="menu-item consultation"
        [title]="'무료 상담하기' | translate"
        (click)="onConsultationClick()"
      >
        <i class="bi bi-chat-dots-fill w-auto h-auto"></i>
        <span>{{ '무료 상담하기' | translate }}</span>
      </a>
    </li>
    <li>
      <a
        href="https://www.instagram.com"
        target="_blank"
        rel="noopener noreferrer"
        class="menu-item instagram"
        [title]="'인스타그램' | translate"
      >
        <i class="bi bi-instagram w-auto h-auto"></i>
        <span>{{ '인스타그램' | translate }}</span>
      </a>
    </li>
    <li>
      <a
        class="menu-item message"
        [title]="'메시지' | translate"
        (click)="onMessageClick()"
      >
        <i class="bi bi-envelope-fill w-auto h-auto"></i>
        <span>{{ '메시지' | translate }}</span>
      </a>
    </li>
  </ul>
</div>

<!--
  푸터 컴포넌트
  - footerFlg 값에 따라 조건부 렌더링
  - 기본적으로 표시됨 (footerFlg 기본값: true)
-->
@if (footerFlg) {
  <footer role="contentinfo">
    <app-template-footer></app-template-footer>
  </footer>
}

<!--
  사이드 메뉴 (오프캔버스)
  - 모바일 화면에서 사용되는 드로어 메뉴
  - Bootstrap의 offcanvas 컴포넌트 사용
-->
<nav role="navigation" aria-label="사이드 메뉴">
  <div class="offcanvas offcanvas-end">
    <app-drawer
      fixedInViewport="true"
      [userInfo]="userInfo"
      [userCard]="userCard"
      (refreshInfoClick)="onRefreshInfoClick()"
    ></app-drawer>
  </div>
</nav>

<!--
  로딩 인디케이터
  - 전역 로딩 상태를 표시하는 컴포넌트
-->
<app-loading></app-loading>
